document.addEventListener('DOMContentLoaded', () => {

  const screenHeight = window.innerHeight;
  const triggerValue = Math.round(screenHeight / 3);

  function visualyDebug(selector) {
    const elements = typeof(selector) == 'string' ? document.querySelectorAll(selector) : [selector];
    elements.forEach(function(element) {
      element.style.outline = '1px solid red';
    });
  }

  function debugLine(position, value) {
    const debugElement = document.createElement('div');
    debugElement.setAttribute('style', 'height: 0px; position: fixed; ' + position + ': ' + value + 'px; left: 0; width: 100%; z-index: 1000;');
    document.body.appendChild(debugElement);
    visualyDebug(debugElement);
  }
  // debugLine('top', triggerValue);

  const anchors = document.querySelectorAll('.js-anchor-threshold');
  // anchors.forEach((anchor) => {
  //   anchor.addEventListener('click', (e) => {
  //     e.preventDefault();
  //   });
  // });

  document.addEventListener('scroll', function() {
    let lastActiveAnchor = null;
    anchors.forEach((anchor) => {
      // const listenedElementWindowBottom = screenHeight - anchor.getBoundingClientRect().top;
      // if (listenedElementWindowBottom > triggerValue) {
      //   // upside
      //   lastActiveAnchor = anchor;
      // }
      const listenedElementWindowTop = anchor.getBoundingClientRect().top;
      if (listenedElementWindowTop < triggerValue) {
        // upside
        lastActiveAnchor = anchor;
      }
    });

    let navAnchor = null;
    if (lastActiveAnchor) {
      navAnchor = document.querySelector('.js-nav-anchor[href="#' + lastActiveAnchor.id + '"]');
    }

    const currentNavAnchor = document.querySelector('.l-nav__anchor--active');
    if (navAnchor != currentNavAnchor) {
      if (navAnchor) {
        navAnchor.classList.add('l-nav__anchor--active');
      }
      if (currentNavAnchor) {
        currentNavAnchor.classList.remove('l-nav__anchor--active');
      }
    }
  });
  window.dispatchEvent(new Event('scroll'));

  document.querySelectorAll('.js-nav-anchor').forEach((anchor) => {
    anchor.addEventListener('click', (e) => {
      window.forceHideStickyMenu = true;
      setTimeout(() => {
        window.forceHideStickyMenu = false;
      }, 1000);
    });
  });
});
